import styles from "./CreateMap.module.css";
import about01 from "../../img/create_map_process_01.png";
import about02 from "../../img/create_map_process_02.png";
import about03 from "../../img/create_map_process_03.png";
import about04 from "../../img/create_map_process_04.png";
import arrow from "../../img/right_arrow.png";
import ListView from "../common/ListView";

export interface CreateMapProcessProps {
    src: string;
    content?: string | undefined;
}

/**
 * @author sukim91
 * @date 2022-09-27 14:41:33
 * @remark 지도만들기 절차 컴포넌트
 * @param props CreateMapProcessProps
 * @props CreateMapProcessProps
 *      src(required) : 이미지 경로
 *      content : 이미지 하단에 작성되는 컨텐츠 내용
 * @returns <div>
 */
function CreateMapProcess() {
    const createMapProcessItem = [
        {
            src: about01,
            content: "데이터 입력",
        },
        {
            src: arrow,
        },
        {
            src: about02,
            content: "옵션설정",
        },
        {
            src: arrow,
        },
        {
            src: about03,
            content: "지도제작",
        },
        {
            src: arrow,
        },
        {
            src: about04,
            content: "마이지도",
        },
    ];

    const renderItem = (props: CreateMapProcessProps) => {
        return props.content ? (
            <div className={styles.process}>
                <img src={props.src} className={styles.img} />
                <span className={styles.content}>{props.content}</span>
            </div>
        ) : (
            <img src={props.src} className={styles.arrow} />
        );
    };

    return (
        <div className={styles.processWrapper}>
            <ListView data={createMapProcessItem} renderItem={renderItem} />
        </div>
    );
}

export default CreateMapProcess;
